import SplashLoader from '@shared/components/loading/SplashLoader';
import AlertsContainer from '@shared/hooks/state/AlertsContainer';
import AuthContainer from '@shared/hooks/state/AuthContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

const LOGIN_PATH = '../login';
const HOME_PATH = '../';

const AuthCallbackPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const queryCode = searchParams.get('code');

    const authContainer = AuthContainer.useContainer();
    const alertsContainer = AlertsContainer.useContainer();

    const tryInitializeFromStorage = async () => {
        try {
            const result = await authContainer.initializeFromStorage();
            if (result) {
                navigate(HOME_PATH, { replace: true, viewTransition: true });
            } else {
                errorReset();
            }
        } catch (error) {
            errorReset();
        }
    };
    const errorReset = () => {
        alertsContainer.showError(t('common:login.error'));
        if (!authContainer.isLoading) {
            navigate(LOGIN_PATH, { replace: true, viewTransition: true });
        }
    };

    const fetchData = async () => {
        try {
            const result = await authContainer.loginFromCode(queryCode || '');
            if (result?.resultType == 'Ok') {
                navigate(HOME_PATH, { replace: true, viewTransition: true });
            } else {
                tryInitializeFromStorage();
            }
        } catch (error) {
            errorReset();
        }
    };

    useEffect(() => {
        if (!queryCode) {
            navigate(LOGIN_PATH, { replace: true, viewTransition: true });
        }
        if (!authContainer.isAuthenticatedRef.current) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <SplashLoader text={t('common:authenticating')} refreshButton />;
};

export default AuthCallbackPage;
